import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import {
  FormControl,
  makeStyles,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import { answerAQuestion } from 'store/polling'

const PollQuestionAttempt = ({ question }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { answeredBy, answers } = useSelector((state) => state.polling)

  const alreadyAnswered = answers?.find(
    (doc) =>
      doc?.answeredBy?.toLowerCase() === answeredBy?.toLowerCase() && doc.questionId === question.id
  )

  const handleChange = (event) => {
    const answerId = alreadyAnswered?.id ?? null
    dispatch(
      answerAQuestion(answerId, {
        optId: event.target.value,
        questionId: question?.id,
        pollId: question?.pollId,
        answeredBy: answeredBy
      })
    )
  }
  return (
    <FormControl style={{ width: '100%' }}>
      <Typography className={classes.questionTitle}>{question?.title}</Typography>
      <RadioGroup
        className={classes.radioGroup}
        name="controlled-radio-buttons-group"
        value={alreadyAnswered?.id ? alreadyAnswered?.optId : ''}
        onChange={handleChange}>
        {question?.options?.map((option) => (
          <Box className={classes.radioLabel} key={option.optId}>
            <FormControlLabel
              className={
                alreadyAnswered?.id && alreadyAnswered.optId === option.optId
                  ? classes.checkedRadio
                  : classes.selectedRadio
              }
              value={option.optId}
              control={<Radio className={classes.radio} />}
              label={option.opt}
            />
          </Box>
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default PollQuestionAttempt

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%'
  },
  questionTitle: {
    fontWeight: '600',
    margin: '16px 0px',
    fontSize: '20px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      textAlign: 'start'
    }
  },
  radio: {
    padding: '4px',
    '& .MuiIconButton-label': {
      display: 'none'
    }
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  radioLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  selectedRadio: {
    padding: '14px 6px',
    backgroundColor: '#e0e0e0',
    width: '350px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    margin: '0px'
  },
  checkedRadio: {
    padding: '14px 6px',
    backgroundColor: '#2196f3',
    color: '#FFFFFF',
    margin: '0px',
    '& .MuiTypography-root': {
      fontSize: '15px',
      fontWeight: '500'
    },
    width: '350px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))
